// extracted by mini-css-extract-plugin
export default {"ErrorTextWrapper":"AlertError_ErrorTextWrapper__t4iIF"};